export const GET_EMAIL = 'GET_EMAIL';
export const GET_CODE = 'GET_CODE';
export const FOCUS_WINDOW_CHANGE_FOCUS = 'FOCUS_WINDOW_CHANGE_FOCUS';
export const FETCH_SIGNED_FILE_COOKIE = 'FETCH_SIGNED_FILE_COOKIE';
